import React, { Component } from 'react';
export const DemoIndicator = () => {
  // Component now returns null to remove the demo notice completely
  return null;
};